// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("rails-ujs").start();
console.log("hei");
require("turbolinks").start();
// require("@rails/activestorage").start()

require("channels");
require("chart.js");
require("chartkick");
require("autocomplete.js");
console.log("hei");
require("local-time").start();
//window.Rails = Rails
import("stylesheets/application.scss");
import "controllers";
const images = require.context('../images', true)
// import "controllers";

// kk
// 		TODO : Import flatpickr on all date fields
//		https://www.youtube.com/watch?v=Hz8d6zPDSrk
// import flatpickr from flatpickr
// document.addEventListener("turbolinks:load", () => {
// 	flatpickr("[data-behavior='flatpickr']", {
// 		altInput: true,
// 		altFormat: "F j, Y",
// 		dateFormat: "Y-m-d",
//
//
// 	})
// })

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// import "stylesheets/application.scss"
// require("@rails/actiontext")

// import "controllers";

import "controllers"
import 'trix/dist/trix.css';
require("trix")
